export default __webpack_public_path__ + "static/media/home.ec9c7ac7.PNG";